import { SelectOptionType } from "../../../../types/types";

export const HIDE_REMINDERS = false;

export type ReminderDateDirection = "before" | "after";
export type ReminderDateBase = "dueDate" | "startDate";

export type ReminderItem = {
  id: string;
  workId: string;
  notifyUserId: string;
  notifyUserName: string;
  days: number;
  direction: ReminderDateDirection;
  dateBase: ReminderDateBase;
  createdAt: string;
  isSent?: boolean;
  /** 9:00 AM local on the reminder day, from the work's current dates. */
  goesOffAt?: Date | null;
};

export type ReminderDraft = {
  days: string;
  direction: ReminderDateDirection;
  dateBase: ReminderDateBase;
  notifyUserId: string;
};

export const REMINDER_DIRECTION_OPTIONS: SelectOptionType[] = [
  { label: "before", value: "before" },
  { label: "after", value: "after" },
];

export const REMINDER_DATE_BASE_OPTIONS: SelectOptionType[] = [
  { label: "due date", value: "dueDate" },
  { label: "start date", value: "startDate" },
];
